import 'swiper/css'
import 'swiper/css/pagination'
import jQuery from 'jquery'
import PropTypes from 'prop-types'
import notify from 'components/UI/toast'
import React, { useEffect, useState } from 'react'
import { Pagination } from 'swiper/modules'
import { useNavigate } from 'react-router-dom'
import { Container, Img, Span, DesktopGrid } from './styles'
import { Swiper, SwiperSlide } from 'swiper/react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { trackClick } from '../../utils/gtm'
import { tagIdFromLegacySuffix } from '../../utils/marketplaceTagIds'
import { useScreenTracking } from '../../hooks/useScreenTracking'

export default function FeaturedCategories ({ categoriesData }) {
  const navigate = useNavigate()
  const [Loading, setLoading] = useState(true)
  const [categories, setCategories] = useState([])
  const screenName = useScreenTracking()
  const isDesktop = useMediaQuery('(min-width:1024px)')

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true)
      try {
        setCategories([...categoriesData])
        setLoading(false)
      } catch (err) {
        notify('Erro ao tentar carregar categorias', 'error')
      }
    }
    fetchCategories()
  }, [])

  function RoutesCategories (id, label) {
    trackClick({
      title: `categoria-${label.toLowerCase().replace(/\s/g, '-')}`,
      contentType: "categorias-em-destaque",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    })
    navigate('/loja/category/' + id)
  }

  return (
    !Loading && (
      <Container>
        {isDesktop ? (
          <DesktopGrid>
            {categories.map((category, index) => {
              const { id, label, image } = category
              return (
                <div className="grid-card" key={index + 'grid'}>
                  <Img
                    src={image}
                    alt={label}
                    key={id + 'img'}
                    onClick={() => RoutesCategories(id, label)}
                  />
                  <div>
                    <Span
                      key={index + 'span'}
                      style={{ paddingBottom: 5 }}
                      className="font-wl-500"
                      onClick={() => RoutesCategories(id, label)}
                    >
                      {label}
                    </Span>
                  </div>
                </div>
              )
            })}
          </DesktopGrid>
        ) : (
        <Swiper
          slidesPerView={2.5}
          breakpoints={{
            568: { slidesPerView: 4 }
          }}
          spaceBetween={30}
          pagination={{
            clickable: true
          }}
          modules={[Pagination]}
          className="mySwiper mySwiperCategories margin-right-minus-25"
          onSlideChange={(swiper) => {
            let isEnd = swiper.isEnd;
            if (isEnd) {
              jQuery('.mySwiperCategories').removeClass('margin-right-minus-25');
              jQuery('.mySwiperCategories').addClass('margin-left-minus-25');
            } else {
              jQuery('.mySwiperCategories').removeClass('margin-left-minus-25');
              jQuery('.mySwiperCategories').addClass('margin-right-minus-25');
            }
          }}
        >
          {categories.map((category, index) => {
            const { id, label, image } = category
            return (
              <SwiperSlide key={index + 'swipper'}>
                <Img 
                  src={image} 
                  alt={label}
                  key={id + 'img'} 
                  onClick={() => RoutesCategories(id, label)} 
                />
                <div>
                  <Span 
                    key={index + 'span'} 
                    style={{paddingBottom:5}} 
                    className="font-wl-500 text-left" 
                    onClick={() => RoutesCategories(id, label)}>{label}
                  </Span>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
        )}
      </Container>
    )
  )
}

FeaturedCategories.propTypes = {
  categoriesData: PropTypes.array
}